import { METRIC_CHIP_RE } from './tokenize'

const PLACEHOLDER = '\u0007'

/** Preserve metric chips while stripping every non-grammar character from pasted content. */
export function sanitize(formula: string): string {
  if (!formula) return ''
  const chips: string[] = []
  const withoutMarkup = formula.replace(/<[^>]*>/gu, '')
  const protectedFormula = withoutMarkup.replace(METRIC_CHIP_RE, (chip) => {
    chips.push(chip)
    return PLACEHOLDER
  })
  const cleaned = protectedFormula.replace(new RegExp(`[^0-9+\\-*/().\\s${PLACEHOLDER}]`, 'gu'), '')
  let index = 0
  return cleaned
    .replace(new RegExp(PLACEHOLDER, 'gu'), () => chips[index++] ?? '')
    .replace(/\s+/gu, ' ')
    .trim()
}
